<template>
  <div>
    <top-bar/>
    <menu-dash/>
    <div class="w3-main" style="margin-left:300px;margin-top:50px;">
      <header class="w3-container" style="padding-top:14px">
        <h6><b><i class="fa fa-dashboard"></i> Dashboard</b></h6>
      </header>
      <div class="w3-padding">

        <a href="javascript:" v-if="deferredPrompt" @click="installPWA">
          <div class="w3-padding w3-padding-16 w3-blue-gray w3-card w3-round-small w3-small avisos w3-animate-left">
            <div class="w3-cell-row">
              <div class="w3-cell w3-cell-middle w3-center" style="padding-right: 16px; width: 60px">
                <i class="fa fa-mobile-phone fa-3x"></i>
              </div>
              <div class="w3-cell w3-cell-middle">
                <h6 style="margin-bottom: 0"><b>Baixe o APP da CodeMarket!</b></h6>
                <h6 class="w3-small" style="margin-top: 0">Clique aqui para baixar o WebApp da CodeMaket.</h6>
              </div>
            </div>
          </div>
        </a>

      </div>
      <div class="w3-row-padding w3-margin-bottom">
        <div class="w3-col s6 m4 l3 w3-margin-bottom">
          <router-link to="/admin/pdv">
            <div class="w3-container primary w3-round w3-padding-16 w3-center">
              <i class="fa fa-shopping-bag w3-xlarge"></i>
              <div class="w3-clear"></div>
              <h6 class="w3-small"><b>COMPRAR</b></h6>
            </div>
          </router-link>
        </div>
        <div class="w3-col s6 m4 l3 w3-margin-bottom">
          <router-link to="/admin/minhas-compras">
            <div class="w3-container primary w3-round w3-padding-16 w3-center">
              <i class="fa fa-shopping-basket w3-xlarge"></i>
              <div class="w3-clear"></div>
              <h6 class="w3-small"><b>MINHAS COMPRAS</b></h6>
            </div>
          </router-link>
        </div>
      </div>
    </div>

    <pagar-amigo @atualizar="$emit('buscarNotificacoes')"/>
  </div>
</template>

<script>
  import TopBar from "../commons/TopBar.vue"
  import MenuDash from "../commons/MenuDash.vue"
  import PagarAmigo from "../commons/PagarAmigo.vue"

  export default {
    components: {TopBar, MenuDash, PagarAmigo},
    data() {
      return {
        avsInicio: false,
        adm: false,
        permissoes: [],
        usuario: '',

        deferredPrompt: false
      }
    },

    methods: {
      getLStorage(item) {
        return localStorage.getItem(item);
      },

      installPWA() {
        this.deferredPrompt.prompt();
        this.deferredPrompt.userChoice.then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            openModalMsg("Obrigado por instalar nosso WebApp!", "Aguarde, em instantes estará disponível na sua HomePage.");
          }
        })
      }
    },

    mounted() {
      this.adm = !!localStorage.getItem('administrativo');
      if (this.getLStorage('usuario')) {
        this.usuario = JSON.parse(this.getLStorage('usuario'));
      }

      this.deferredPrompt = deferredPrompt;
      setTimeout(() => {
        if (!this.deferredPrompt && deferredPrompt) {
          this.deferredPrompt = deferredPrompt;
        }
      }, 2000);
    }
  }
</script>

<style scoped>
  .avisos {
    margin-bottom: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/Dashboard.vue